import { Button, Col, Flex, Form, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormDatePicker } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import { useCallback, useEffect } from "react";

function OvertimeRecalModal({
    isModalOpen = false,
    onCancel = () => { },
    onFinish = () => { },
    payrollPeriod = {},
    action = "",
    form = null
}) {
    // const [form] = useForm(form)
    const { t, i18n } = useTranslation();

    console.log("payrollPeriod", payrollPeriod);

    // const [form] = useForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const formItemLayout = {
        labelCol: { span: 8 }, // Adjust the span as needed
    };

    useEffect(() => {
        form?.resetFields?.()
    }, [form])

    const modal = useCallback(
        () => {
            return <Modal
                width="30%"
                destroyOnClose
                footer={() => {
                    return (
                        <Row justify='end'>
                            <Space direction="horizontal" size="middle">
                                <Button
                                    onClick={() => {
                                        // * onCancel
                                        onCancel()
                                        form.resetFields();
                                    }}
                                    type="default"
                                    style={{ height: "40px", borderRadius: "8px" }}
                                >
                                    {t("common.cancel")}
                                </Button>
                                {action == 'view' ? null :
                                    <Button
                                        onClick={() => {
                                            form.submit();
                                            // form.resetFields()
                                        }}
                                        type="primary"
                                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}
                                    >
                                        {t("common.confirm")}
                                    </Button>
                                }
                            </Space>
                        </Row >
                    )
                }
                }
                // destroyOnClose={true}
                title={t('payroll-payment.header.edit-overtime')}
                onCancel={() => {
                    form.resetFields()
                    onCancel()
                }}
                open={isModalOpen}
                onOk={(e) => {
                    form.submit()
                    form.resetFields()
                }}

                closable={false}
                maskClosable={false}
            >
                <FormAntd
                    {...formItemLayout}
                    colon={false}
                    form={form}
                    onFinish={(val) => {
                        const modifiedReq = {
                            ...val,
                            // paymentDate: dayjs(val?.paymentDate).format("YYYY-MM-DD")
                        }
                        onFinish(modifiedReq)
                        // form.resetFields()
                    }}
                    initialValues={{
                        ...payrollPeriod,
                        // paymentDate: payrollPeriod?.paymentDate ? dayjs(payrollPeriod?.paymentDate) : null
                    }}

                    requiredMark={(label, { required }) => {
                        if (required) {
                            return (
                                <Flex>
                                    {label}
                                    {<span style={{ color: "red" }}>*</span>}
                                </Flex>)
                        } else {
                            return label
                        }
                    }
                    }
                >
                    <Form.Item shouldUpdate  {...formItemLayout}>
                        {({ getFieldsValue, getFieldValue, setFieldValue }) => {
                            return (
                                <Col span={24}>
                                    <FormDatePicker
                                        name="overtimePaymentDate"
                                        type="range"
                                        label={t('start-date-to-end-date')}
                                        placeholder={[t('common.please_select_start_date'), t('holiday.label.end_date')]}
                                        size="large"
                                    />
                                </Col>
                            )
                        }}
                    </Form.Item>
                </FormAntd>
            </Modal>
        },
        [t, isModalOpen, formItemLayout, form, payrollPeriod, action, onCancel, onFinish],
    )

    return (
        modal()
    )

}

export default OvertimeRecalModal